import { render, staticRenderFns } from "./PolicyActions2.vue?vue&type=template&id=da116d50"
import script from "./PolicyActions2.vue?vue&type=script&lang=js"
export * from "./PolicyActions2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports